export const getPercentageFromValues = <T extends Record<string, number>>(
  values: T,
  withPercent = false
): T => {
  const sum = Object.values(values).reduce((acc, value) => +acc + +value, 0);
  if (sum === 0) {
    return Object.entries(values).reduce((acc, [key, value]) => {
      (acc as unknown as Record<string, string>)[key] =
        "0" + (withPercent ? "%" : "");
      return acc;
    }, {} as T);
  }

  const percentages: T = Object.entries(values).reduce((acc, [key, value]) => {
    let formatted: string;
    const percentage = (value / sum) * 100;
    if (percentage === 0) {
      formatted = "0" + (withPercent ? "%" : "");
    } else {
      formatted = percentage.toFixed(1) + (withPercent ? "%" : "");
    }
    // Assign to a string record, not T, to avoid type issues
    (acc as unknown as Record<string, string>)[key] = formatted;
    return acc;
  }, {} as T);

  return percentages;
};
